import apiUrl from '../../../../constants';
import axios from 'axios';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select'
import Printd from 'printd'
import moment from 'moment'
import common_helper from '../../../../common_helper'

import {
    WebCam
} from "vue-web-cam"

export default {
    name: 'newreturnsmanifest',
    components: {
        vSelect,
        DatePicker,
        VueElementLoading,
        BasicSelect,
        Printd,
        moment,
        WebCam
    },
    props: [],
    data() {
        return {
            isLoading: false,
			is_Loading: false,
            loadingText: '<i class="faveImage fa-spinner fa-spin"></i> Loading...',
			loading: false,
            channelErrors: {},
            showSelectClient: false,
            showSelectWarehouse: false,
            listClientData: [],
            listWarehouseData: [],
            saleschannellist: [],
            referenceNo: '',
            createdbyEmail: '',
            client:'',
            warehouse:'',
            clientid: '',
            clientToken: '',
            warehouseid: '',
            warehouseName: '',
            modalMessageShowpo: false,
            printManifestModal : false,
            uploadReturnsManifest:false,
            closeReturnsManifest:false,
            courier:'',
            courierList:[],
            courierList1:[],
            couriererr:'',
            clientItem: {},
            warehouseItem:{},
            salesChannelItem:{},
            awbnoForSearch:'',
            awbno: '',
            selectfileFlag : false,
            cameraSection : false,
			fileSection : false,
			cameraImage : null,
			selectFirstDevice: true,
			screenshotFormat: "image/jpeg",
            isdisableValue: false,
            HandoverPersonName: '',
            manifest_date:'',
            contactNO: '',
            totalPage: 0,
			totalCount: 0,
			pageLimit: 10,
            resultCount: '',
            cameralist : '',
			file :'',
			showfileselect : false,
			showcameraselect : false,
			cameras : '',
            uploadedImagesCount : 0 ,
            awbnoForSearch: '',
            awbs: [],
            showAWBDeatils:false,
            showCourier:true,
            ClosedmanifestShow:false,
            showPrintUpload :false,
            removeAWBConfirmModel:false,
            awbToRemove:null,
            manifestDetails:[],
            manifestid :'',
		    manifest_status : '',
            wmsclientname:'',
            wmswarehousename:'',
            screenshotFormat: "image/jpeg",
			playsinline: false,
			autoplay: true,
			imageCaptured : false,
			PrintDetails:[],
            aWBNumberError:'',
            HandoverPersonNameError:'',
            contactNOError:'',
            currentPage: 1,
            filteredAWBs:'',
            showMsg:true,
            item: {
				value: '',
				text: ''
			},
            uploadedImages: [],
            isModalVisible: false,
            otherCourierDetails: '',
            otherCourierDetailsError:''
        };
    },
    computed: {
        totalAWBs() {
          return this.manifestDetails.length;
        },
        filteredAWBs() {
            if (this.awbnoForSearch === '') {
              return this.manifestDetails;
            }
            const search = this.awbnoForSearch.toLowerCase();
            return this.manifestDetails.filter(awb =>
              awb.awbno.toLowerCase().includes(search)
            );
          }
      
      },
    mounted() {
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.user_type = userdetail.utype;
        this.useremail = userdetail.email;
        this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
        this.addWarehouseList();
        this.getCourierList();
        switch (this.user_type) {
            case 'system_user':
                console.log("system_user")
                this.showSelectClient = true;
                this.showSelectWarehouse = true;
                this.createdbyEmail = userdetail.email;
                // this.getClientList();
                // this.getWarehouseList();
                break;

            case 'client_user':
                console.log("client_user")
                this.clientid = this.addChannel.clientid = userdetail.clientid;
                this.createdbyEmail = userdetail.email;
                this.showSelectWarehouse = true;
                // this.getClientList();
                // this.getWarehouseList();
                break;

            case 'warehouse_user':
                console.log("warehouse_user")
                this.warehouseid = this.addChannel.warehouseid = userdetail.warehouseid;
                this.createdbyEmail = userdetail.email;
                this.showSelectClient = true;
                // this.getClientList();
                // this.getWarehouseList();
                break;

            default:
                console.log("default")
                this.$alertify.error("Unauthorised user, Please contact your system admin");
                break
        }
    },
    methods: {
        handleEnter(event) {
            // Custom logic for Enter key press
            console.log('Enter key pressed, but default action is prevented');
          },
        showList() {
            // this.modalMessageShowpo = false;
            this.warehouseItem.value=this.warehouseItem.value;
            this.$emit("goBackToParent", this.clientItem, this.warehouseItem)
        },
        // getClientList() {
        //     if (window.localStorage.getItem("clientList") !== null) {
        //         var clientListEncrypt = window.localStorage.getItem('clientList');
        //         var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
        //         var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
        //         this.getClientSelectOptions(JSON.parse(plaintextclient));
        //     } else {
        //         var userToken = window.localStorage.getItem('userToken');
        //         var myStr = userToken.replace(/"/g, '');
        //         axios({
        //             method: 'POST',
        //             'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
        //             'data': {},
        //             headers: {
        //                 'Authorization': 'Bearer ' + myStr,
        //             }
        //         })
        //             .then(result => {
        //                 this.getClientSelectOptions(result.data.data);
        //             }, error => {
        //                 console.error(error);
        //             });
        //     }
        // },
        addWarehouseList() {
            if (window.localStorage.getItem("warehouseList") !== null) {
                var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
                var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
                var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
                this.getWarehouseSelectOptions(JSON.parse(plaintextwarehouse));
            } else {
                var userToken = window.localStorage.getItem('userToken')
                var myStr = userToken.replace(/"/g, '');
                this.input = ({
                    clientid: this.clientid,
                });

                axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                    .then(result => {
                        this.getWarehouseSelectOptions(result.data.data);
                    }, error => {
                        console.error(error)
                    })
            }
        },
        
        resetForm() {
            this.clientItem={};
            this.warehouseItem={};
         
        },
        clientSelected(item) {
            this.clientItem=item;
            if(this.clientid != this.clientItem.value){
                this.addChannel.clientid = item.value;
                this.clientid = this.addChannel.clientid;
                this.addChannel.saleschannel = '';
                this.saleschannellist = [];
                this.salesChannelItem={};
                this.getSalesChannels();
                if (this.user_type != 'warehouse_user') {
                    this.warehouseid='';
                    this.addChannel.warehouseid='';
                    this.listWarehouseData = [];
                    this.warehouseItem={};
                    this.getWarehouseList();
                  }
            }
        },
        warehouseSelected(item) {
            this.warehouseItem=item;
            this.addChannel.warehouseid=window.localStorage.getItem('selectedWarehouse');
            this.addChannel.warehousename=item.text;
            this.warehouseid = this.addChannel.warehouseid;
            if (this.warehouseid) {
                if (!this.clientid) {
                    this.getClientList();
                } else {
                    this.getSalesChannels();
                }
            }
        },

        
        getClientToken(clientid) {
            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');
            return axios({
                method: 'POST',
                'url': apiUrl.api_url + 'generateClientToken',
                'data': { "clientid": clientid },
                headers: {
                    'Authorization': 'Bearer ' + myStr,
                }
            })
                .then(result => {
                    this.clientToken = result.data.token;
                }, error => {
                    console.error(error);
                });
        },
        getWarehouseName(warehouseid) {
            if (this.listWarehouseData.length > 0) {
                for (let warehouse of this.listWarehouseData) {
                    if (JSON.stringify(warehouse.value) === warehouseid) {
                        console.log(warehouse.text)
                        return warehouse.text;
                    }
                }
            }
            return '';
        },
        getClientSelectOptions(data){
            this.clientItem = {
                value: '',
                text: ''
            };
            this.listClientData = [{
                value: '',
                text: this.$t('common.clientPlaceholder')
            }];
            data.forEach(ele => {
                this.listClientData.push({
                    "value": ele.clientid,
                    "text": ele.clientname
                })
            })
        },
        getWarehouseSelectOptions(data){
            this.warehouseItem = {
                value: '',
                text: ''
            };
            this.listWarehouseData = [{
                value: '',
                text: this.$t('common.warehousePlaceholder')
            }];
            data.forEach(ele => {
                this.listWarehouseData.push({
                    "value": ele.warehouseid,
                    "text": ele.warehousename
                })
            })
        },
        onPageChange(page) {
            this.currentPage = page;
            this.getReturnsManifestData()
          },
        onSelect(item) {
			// select option from parent component
			this.item = item
			this.courier = item.text;            
            if (item.text === 'Other') {
                this.openModal(); // Open the modal if 'Other' is selected
            }
		},
        openModal() {
            this.isModalVisible = true;
            this.otherCourierDetailsError = "";
          },
        closeModal() {
            this.isModalVisible = false;
            this.otherCourierDetails = ''; 
            this.item = {
                        value: '',
                        text: ''
            }
             this.courier = '';
             this.otherCourierDetailsError = "";
        },
        getCourierList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			let params= {
                clientid: localStorage.getItem("selectedClient"),
                warehouseid:window.localStorage.getItem("selectedWarehouse"),
            }
            axios({
                method: 'GET',
                url:`${apiUrl.api_url}courierlistRTO/${params.clientid}/${params.warehouseid}`,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
                })
				.then(result => {
                    this.courierList = result.data.data;
                    // this.item = {
                    //     value: '',
                    //     text: ''
                    // },
                    this.courierList1 = [{ value: '', text: this.$t('common.courierCompanyPlaceHolder') }]
                    this.courierList.forEach(ele => {
                        this.courierList1.push({
                            "value": ele.id,
                            "text": ele.couriername
                        })
                    })
                    this.courierList1.push({
                        "value": 'other',
                        "text": "Other"
                    })
				}, error => {
					console.error(error)
				})
		},
        saveOtherCourier() {
            var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
            if (!this.otherCourierDetails) {
                //this.$alertify.error('Courier details cannot be empty.');
                this.otherCourierDetailsError = "Courier details cannot be empty."
                return; 
            }
        
            const courierExists = this.courierList.some(ele => ele.couriername === this.otherCourierDetails);
            if (courierExists) {
                this.otherCourierDetailsError = 'Courier name already exists.'
                return;
            }
            const newCourier = {
                value: this.otherCourierDetails,
                text: this.otherCourierDetails
              };
              axios({
                method: 'POST',
                'url': apiUrl.api_url + 'saveReturnsCourierDetails',
                'data': {
                    clientid: window.localStorage.getItem("selectedClient"),
                   // warehouseid:window.localStorage.getItem("selectedWarehouse"),
                    useremail:this.useremail,
                    couriername:this.otherCourierDetails   
                },
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
            .then(result => {
                if (result.data.status == true) {
                    this.$alertify.success(result.data.msg);
                    this.getCourierList();
                    this.item = {
                        value: this.otherCourierDetails,
                        text: this.otherCourierDetails
                    },
                    this.courier = newCourier.text;
                    this.isModalVisible = false;
                    this.otherCourierDetails = ''; 
                }else{
                    this.$alertify.error(result.data.msg);
                }
            }, error => {
                console.error(error)
            })
        },
        createorShowManifest(){
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            if (window.localStorage.getItem("selectedClient") == 'undefined' ||window.localStorage.getItem("selectedClient") == null || window.localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (window.localStorage.getItem("selectedWarehouse") == 'undefined' || window.localStorage.getItem("selectedWarehouse") == null || window.localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
            if (this.courier == "") {
				this.couriererr = this.$t('courierMapping.transportererr')
				return false;
			}
            axios({
                method: 'POST',
                 'url': apiUrl.api_url + 'checkCreateReturnManifest',
                'data': {
                    clientid: window.localStorage.getItem("selectedClient"),
                    warehouseid:window.localStorage.getItem("selectedWarehouse"),
                    couriercompany:this.courier,
                    useremail:this.useremail
                },
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
            .then(result => {
                if (result.data.status == true) {
                    this.showAWBDeatils = true
                    this.showCourier = false
                    this.manifestDetails = result.data.data.details;
                    this.filteredAWBs = this.manifestDetails;
                    this.manifestid = result.data.data.id;
                    this.manifest_status = result.data.data.manifest_status;
                    if(this.showMsg){
                        this.$alertify.success(result.data.msg)
                    }
               }else{
                this.$alertify.error(result.data.msg)
               }
            }, error => {
                console.error(error)
            })
        },
        resetManifestModal(){
          this.HandoverPersonName = '';
          this.contactNO = '';
        },
        resetManifestAction(){
            this.showAWBDeatils = false
            this.showCourier = true
            this.awbs = []
            this.filteredAWBs = []
            this.courier ='';
            this.showPrintUpload = false;
            this.item = { value: '', text: '' }; 
        },
        addAWB() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            this.aWBNumberError = '';
            if (window.localStorage.getItem("selectedClient") == 'undefined' ||window.localStorage.getItem("selectedClient") == null || window.localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (window.localStorage.getItem("selectedWarehouse") == 'undefined' || window.localStorage.getItem("selectedWarehouse") == null || window.localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
            if (this.awbno == "") {
				this.aWBNumberError = this.$t('supportRequest.aWBNumberError')
				return false;
			}
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'addAWBReturnsManifest',
                'data': {
                    clientid: window.localStorage.getItem("selectedClient"),
                    warehouseid:window.localStorage.getItem("selectedWarehouse"),
                    manifestid : this.manifestid,
                    useremail:this.useremail,
                    awbno :this.awbno      
                },
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
            .then(result => {
                if (result.data.status == true) {
                    this.awbno = '';
                    document.getElementById("awbno").value = "";
                    this.$alertify.success(result.data.msg);
                    this.showMsg = false;
                    this.createorShowManifest();
                }else{
                    this.awbno = '';
                    document.getElementById("awbno").value = "";
                    this.$alertify.error(result.data.msg);
                    this.showMsg = false;
                    this.createorShowManifest();
                }
                
            }, error => {
                console.error(error)
            })
          },
          filterAWBs() {
            const search = this.awbnoForSearch.toLowerCase();
                this.filteredAWBs = this.manifestDetails.filter(awbs =>
                awbs.awbno.toLowerCase().includes(search)
                );
          },
         
          showRemoveModal(awbNo) {
                 this.awbToRemove = awbNo;
                 this.removeAWBConfirmModel = true;   
        
          },
          confirmRemoveAWB() {
            this.removeAWB(this.awbToRemove);
            this.awbToRemove = null;
            this.hideModal();
          },
          hideModal() {
            this.removeAWBConfirmModel = false;
          },
          removeAWB(awbNo) {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            if (window.localStorage.getItem("selectedClient") == 'undefined' ||window.localStorage.getItem("selectedClient") == null || window.localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (window.localStorage.getItem("selectedWarehouse") == 'undefined' || window.localStorage.getItem("selectedWarehouse") == null || window.localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'removeAWBReturnManifest',
                'data': {
                    clientid: window.localStorage.getItem("selectedClient"),
                    warehouseid:window.localStorage.getItem("selectedWarehouse"),
                    awbno :awbNo,
                    useremail:this.useremail,
                    manifestid : this.manifestid  
                },
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
            .then(result => {
                if (result.data.status == true) {
                    this.$alertify.success(result.data.msg);
                    this.showMsg = false;
                    this.createorShowManifest()
                }else{
                    this.$alertify.error(result.data.msg);
                    this.showMsg = false;
                    this.createorShowManifest()
                }
              
            }, error => {
                console.error(error)
            })
          },
        async printManifestAction() {
            var today = new Date();
			this.manifest_date = moment(today).format('DD/MM/YYYY HH:mm:ss');
            if (window.localStorage.getItem("selectedClient") == 'undefined' ||window.localStorage.getItem("selectedClient") == null || window.localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}
			if (window.localStorage.getItem("selectedWarehouse") == 'undefined' || window.localStorage.getItem("selectedWarehouse") == null || window.localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
			this.input = ({
				//warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				manifestid: this.manifestid,
                offset:0,
                limit: 1000,
			});
			let result = await common_helper.getRestApiResponse('POST', 'getManifestDetailsById', this.input, this.$alertify);
            if (result && !result.errorDATA) {
				if (result.data.errorCode == 0) {
					this.PrintDetails =  result.data.data[0];
                    this.AwbDetails = result.data.data;
                    this.wmsclientname = result.data.data[0].clientname;
                    this.wmswarehousename = result.data.data[0].warehousename;

				}
				else if (result.data.data.errorCode == -1) {
					this.$alertify.error(result.data.data.msg)
				}
			 }
            this.printManifestModal = true;
        },
        
        closePrintModal(){
            this.printManifestModal = false;
		},
        print() {

			this.printfun = true;
			const d = new Printd();
			var buffer = '';


            var cssText = `.page-header, .page-header-space {
                height: 100px;
            }

            .page-footer, .page-footer-space {
                height: 70px;

            }

            .page-footer {
                position: fixed;
                margin-top: 2px !important;
                bottom: 0;
                width: 100%;
                border-top: 1px solid black; /* for demo */
                background: yellow; /* for demo */
            }

            .page-header {
                position: fixed;
                top: 0mm;
                width: 100%;
                border-bottom: 1px solid black; /* for demo */
                background: yellow; /* for demo */
            }

           @page {
                margin-top: 20mm;
                margin-bottom: 0mm;
            }
            @media print {
                thead {display: table-header-group;}
                tfoot {display: none !important;  }
                printBody {margin: 0;}
                button {display: none;}
                margin-bottom: 40mm;
                }
                table {
                    border-collapse: collapse;
                    margin-left:0px !important;

                }`;
                 d.print(document.getElementById('printPoContent'), cssText);

		},
        chooseUpload(){
            this.selectfileFlag = true;
		},
        async uploadManifestAction() {
			this.uploadReturnsManifest = true;
		},
        closeUploadModal(){
            this.cameraSection = false;
			this.fileSection = false;
			this.imageCaptured = false;
			this.selectfileFlag = false;
            this.uploadReturnsManifest = false;
		},
        uploadManifestImage(uploadType){
			if(uploadType == 'file')
			{
				this.fileSection = true;
				this.cameraSection = false;
			}
			else{
				this.fileSection = false;
				this.cameraSection = true;
			}
		},
		cameraSelected() {
            this.$refs.cameraImage.changeCamera(this.cameralist)
        },
        camerass(camlist) {
            this.cameras = camlist
        },
		captureImage() {
            this.$refs.cameraImage.pause()
            this.imageCaptured = true
        },
        resetImage() {
            this.imageCaptured = false
            this.$refs.cameraImage.resume()
        },
        handleFileUpload() {
            this.file = this.$refs.file.files[0];
            let imageTypes = ['image/jpeg', 'image/png']
            let imageFormat = this.file.type
            let checkFormat = imageTypes.includes(imageFormat)
            if (!checkFormat) {
                this.file = null
                document.getElementById('file').value = null
                this.$alert(this.$t('grcList.imgFormatErr'))
            }
        },
        async saveImage(inputtype) {
            try {
                if (window.localStorage.getItem("selectedClient") == 'undefined' ||window.localStorage.getItem("selectedClient") == null || window.localStorage.getItem("selectedClient") =='') {
                    this.$alertify.error(this.$t('common.clientError'))
                    return false;
                }
    
                if (window.localStorage.getItem("selectedWarehouse") == 'undefined' || window.localStorage.getItem("selectedWarehouse") == null || window.localStorage.getItem("selectedWarehouse")=='') {
                    this.$alertify.error(this.$t('common.warehouseError'))
                    return false;
                }
                this.showfileselect = false
                this.showcameraselect = false
                if (!this.imageCaptured && inputtype == 'camera') {
                    this.$alert(this.$t('grcList.captureImg'))
                    return false
                } else if (!this.file && inputtype == 'file') {
                    this.$alert(this.$t('grcList.selectImg'))
                    return false
                }
                if (inputtype == 'file') {
                    var imgpath = document.getElementById('file');
                    if (!imgpath.value == "") {
                        var img = imgpath.files[0].size;
                        var imgsize = img / 1024;
                        if (imgsize > 4000) {
                            this.$alert(this.$t('grcList.imgSize4mbErr'))
                            document.getElementById('file').value = null
                            this.file=null
                            return false;
                        }
                    }
                }
                let imageString = ""
                var userToken = window.localStorage.getItem('userToken')
                var myStr = userToken.replace(/"/g, '');
                if (inputtype == "camera") {
                    imageString = this.$refs.cameraImage.capture()
                    if (!common_helper.calculateImageSize(imageString)) {
                        this.$alert(this.$t('grcList.imgSize4mbErr'))
                        this.isLoading = false
                        imageString = ""
                        return false
                    }
                } else {
                    let reader = new FileReader()
                    reader.readAsDataURL(this.file)
                    imageString = await new Promise((resolve, reject) => {
                        reader.onload = function() {
                            this.base64String = reader.result.replace("", "")
                            resolve(this.base64String)
                        }
                    })
                }
                let inputpayload = {
                    clientid : Number(localStorage.getItem("selectedClient")),
					manifestid :  this.manifestid,
					imagestring : imageString
                }
                this.isLoading = true

                let Result = await common_helper.getRestApiResponse('POST', 'uploadImageReturnsManifest', inputpayload, this.$alertify)

				if(Result.data.data.status == true){
					this.$alertify.success(Result.data.data.data);
                   // this.uploadReturnsManifest = false;
					this.isLoading = false;
					this.cameraSection = false;
					this.fileSection = false;
					this.selectfileFlag = false;
					this.isManifestDocUploaded = true;
					this.uploadedImagesCount = Result.data.data.imageUploadedCount;
                    this.uploadedImages.push({ url: Result.data.data.imageUrl });
					document.getElementById('file').value = null
				}else{
                    this.isLoading = false;
					this.cameraSection = false;
					this.fileSection = false;
					this.selectfileFlag = false;
					this.isManifestDocUploaded = true;
                    this.$alertify.error(Result.data.data.data);
                    document.getElementById('file').value = null
                }
            } catch (err) {
				document.getElementById('file').value = null
                console.log(err)
            }
        },
        openImageInNewTab(imageUrl) {
            window.open(imageUrl, '_blank');
          },
        //closeReturnsManifest
        async closeManifestAction() {
            if (this.manifestDetails.length === 0) {
				//this.aWBNumberError = this.$t('supportRequest.aWBNumberError')
                this.$alertify.error(this.$t('supportRequest.aWBNumberError'));
				return false;
			}
            this.closeReturnsManifest = true;
            
        },
        closeManifestModal(){
            this.HandoverPersonName = '';
            this.contactNO = '';
            this.closeReturnsManifest = false;
        },
        closeManifest(){
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            if (window.localStorage.getItem("selectedClient") == 'undefined' ||window.localStorage.getItem("selectedClient") == null || window.localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (window.localStorage.getItem("selectedWarehouse") == 'undefined' || window.localStorage.getItem("selectedWarehouse") == null || window.localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
          
            if (this.HandoverPersonName == "") {
				this.HandoverPersonNameError = this.$t('warehouses.contactPersonNumberPlaceHolder')
				return false;
			}
            // if (this.contactNO == "") {
			// 	this.contactNOError = this.$t('warehouses.contactPersonNumberError')
			// 	return false;
			// }
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'closeReturnsManifest',
                'data': {
                    clientid: window.localStorage.getItem("selectedClient"),
                    warehouseid:window.localStorage.getItem("selectedWarehouse"),
                    manifestid : this.manifestid,
                    useremail:this.useremail,
                    deliveredby :this.HandoverPersonName,
                    deliverycontact :this.contactNO      
                },
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
            .then(result => {
                if (result.data.status == true) {
                    this.$alertify.success(result.data.msg);
                    this.showPrintUpload = true;
                    this.closeReturnsManifest = false;
                }else{
                    this.$alertify.error(result.data.msg);
                }
            }, error => {
                console.error(error)
            })

        }
    }

};



// WEBPACK FOOTER //
// ./src/views/components/returnsmanifestlist/newreturnsmanifest/newreturnsmanifest.component.js